import { Grid } from "@material-ui/core";
import React, { useEffect, useState } from "react";

export default function SavedCard({ chargeData, setUseSavedCard }) {
  const [cardBrand, setCardBrand] = useState<string>();
  useEffect(() => {
    setCardBrand(chargeData.creditcard.cardBrand);
  }, [chargeData]);
  if (cardBrand) {
    switch (cardBrand) {
      case "visa":
        setCardBrand("/images/visa.webp");
        break;
      case "mastercard":
        setCardBrand("/images/mc.webp");
        break;
      case "jcb":
        setCardBrand("/images/jcb.webp");
        break;
      case "american express":
        setCardBrand("/images/amex.webp");
        break;
      case "diners club":
        setCardBrand("/images/diners.webp");
        break;
      case "discover":
        setCardBrand("/images/discover.webp");
        break;
      default:
        break;
    }
  }
  return (
    <>
      <div className="payjp saved-card-wrapper" id="v2-mdc">
        <form>
          <label className="field text-field" htmlFor="v2-mdc-card-number">
            <Grid
              container
              alignItems="center"
              spacing={2}
              justifyContent="center"
            >
              <Grid item md={3} sm={3} xs={12}>
                <span className="floating-label">クレジットカード番号</span>
              </Grid>
              <Grid item md={6} sm={9} xs={12}>
                <div className="input-wrapper input-saved saved-card">
                  <div className="card-brand">
                    <img src={cardBrand && cardBrand} alt="" />
                  </div>
                  <input
                    type="text"
                    disabled
                    defaultValue={`**** **** **** ${chargeData.creditcard.cardLast4}`}
                  />
                  <div
                    className="change-card"
                    onClick={() => setUseSavedCard(false)}
                  >
                    <span>変更する</span>
                  </div>
                </div>
              </Grid>
            </Grid>
            <span className="text-field__ripple"></span>
            <span className="line-ripple"></span>
          </label>
        </form>
      </div>
    </>
  );
}
